import React from "react";
import { useForm } from "react-hook-form";
import { Form, FormFields, FormTextField, FormNumberTextField, FormActions } from "sprint-common-web";

import { TvSeasonDetails } from "../../../../TvSeriesDetails";
import { CreateSeasonFormInputs } from "./CreateSeasonFormInputs";
import { useCreateSeasonForm } from "./useCreateSeasonForm";

export interface CreateSeasonFormProps {
    onCancel(): void;
    onSubmit(season: TvSeasonDetails): void;
}

export const CreateSeasonForm: React.FunctionComponent<CreateSeasonFormProps> = (props: CreateSeasonFormProps) => {
    const { errors, control, formState, reset, handleSubmit } = useForm<CreateSeasonFormInputs>({
        defaultValues: {
            name: ""
        },
        criteriaMode: "all"
    });

    const { createNewSeason, isSeasonNameUnique, isNewSeasonNumberUnique } = useCreateSeasonForm();

    const handleAddNewSeason = async (inputs: CreateSeasonFormInputs) => {
        const season = await createNewSeason(inputs);
        props.onSubmit(season);
        reset();
    };

    const handleCancelClick = () => {
        props.onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(handleAddNewSeason)}>
            <FormFields>
                <FormTextField
                    label="Name"
                    name="name"
                    control={control}
                    errors={errors}
                    rules={{ required: "Please enter unique Season Name", validate: isSeasonNameUnique }}
                />
                <FormNumberTextField
                    label="Season Number"
                    name="number"
                    control={control}
                    errors={errors}
                    rules={{
                        required: "Please enter Season Number",
                        pattern: {
                            value: /^\d+$/i,
                            message: "Please enter correct Season Number"
                        },
                        validate: isNewSeasonNumberUnique
                    }}
                />
            </FormFields>
            <FormActions isLoading={formState.isSubmitting || formState.isValidating} onCancel={handleCancelClick} />
        </Form>
    );
};
